var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.page_type == 'hub')?_c('Hub'):(_vm.$store.state.page_type == 'search')?_c('Search'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }